import { render } from "./DocumentItemModal.vue?vue&type=template&id=1b576a12&ts=true"
import script from "./DocumentItemModal.vue?vue&type=script&lang=ts"
export * from "./DocumentItemModal.vue?vue&type=script&lang=ts"

import "./DocumentItemModal.vue?vue&type=style&index=0&id=1b576a12&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__